var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.currentPassword.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Huidig wachtwoord")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentPassword,
                    expression: "currentPassword"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.currentPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.currentPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.currentPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.currentPassword.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Huidig wachtwoord")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentPassword,
                    expression: "currentPassword"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.currentPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.currentPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.currentPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-last setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.newPassword.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw wachtwoord")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPassword,
                    expression: "newPassword"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.newPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.newPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.newPassword.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw wachtwoord")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPassword,
                    expression: "newPassword"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.newPassword },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPassword = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.newPassword.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-last setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.newPasswordConfirm.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw wachtwoord confirmatie")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPasswordConfirm,
                    expression: "newPasswordConfirm"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.newPasswordConfirm },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPasswordConfirm = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.newPasswordConfirm.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.newPasswordConfirm.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw wachtwoord confirmatie")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPasswordConfirm,
                    expression: "newPasswordConfirm"
                  }
                ],
                attrs: { type: "password" },
                domProps: { value: _vm.newPasswordConfirm },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPasswordConfirm = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.newPasswordConfirm.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c(
          "button",
          {
            staticClass: "button dub-button dub-button-space",
            on: { click: _vm.editPassword }
          },
          [_vm._v("Gegevens opslaan")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Wachtwoord wijzigen")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eb37e16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb37e16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordEdit.vue
// module id = null
// module chunks = 